import { 
    LOAD_USER_PERMISSIONS_ROLES_DATA_IN_PROGRESS,
    LOAD_USER_PERMISSIONS_ROLES_DATA_SUCCESS,
    LOAD_USER_PERMISSIONS_ROLES_DATA_FAILURE, 
    LOAD_USER_PERMISSIONS_ROLES_NOT_FOUND
  } from "./actions";
  
  const initialState = { isLoading: false, userPermissionsRolesInfo: [], userPermissionsRolesNotFound:[],loaded: false};
  
  export const userPermissionRoleData= (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {    
        
        case LOAD_USER_PERMISSIONS_ROLES_DATA_SUCCESS: {
        const { data } = payload;
        return {
            ...state,
            isLoading: false,
            userPermissionsRolesInfo: data,
            userPermissionsRolesNotFound:[],
            loaded: true
        };
        }
        case LOAD_USER_PERMISSIONS_ROLES_DATA_IN_PROGRESS:
        return {
            ...state,
            isLoading: true,
        };
        case LOAD_USER_PERMISSIONS_ROLES_NOT_FOUND: {
        const { data } = payload;
        return {
            ...state,
            isLoading: false,
            userPermissionsRolesInfo: [],
            userPermissionsRolesNotFound: data,
             loaded: true
        };
        };
        case LOAD_USER_PERMISSIONS_ROLES_DATA_FAILURE:
        return {
            ...state,
            isLoading: false,
        };   
        default:
        return state;
    }
  };
  